import React, { useState } from 'react';

const OptimizedImage = ({ 
  src, 
  alt, 
  className = '', 
  fallbackIcon = null,
  loading = 'lazy',
  decoding = 'async',
  sizes = '(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw',
  objectFit = 'cover',
  ...props 
}) => {
  const [imageError, setImageError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Generate srcset for different pixel densities if we have a base URL
  const generateSrcSet = (baseUrl) => {
    if (!baseUrl) return undefined;
    
    // For now, just return the original URL
    // In production, you'd want to generate multiple sizes server-side
    return `${baseUrl} 1x, ${baseUrl} 2x`;
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  if (imageError || !src) {
    return (
      <div className={`bg-gradient-to-br from-[#f8fafc] to-[#e2e8f0] flex items-center justify-center border border-gray-200 ${className}`}>
        {fallbackIcon || (
          <svg className="w-1/3 h-1/3 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"/>
          </svg>
        )}
      </div>
    );
  }

  return (
    <div className={`relative ${className}`}>
      {!imageLoaded && (
        <div className={`absolute inset-0 bg-gradient-to-br from-[#f8fafc] to-[#e2e8f0] animate-pulse ${className}`} />
      )}
      <img
        src={src}
        srcSet={generateSrcSet(src)}
        sizes={sizes}
        alt={alt}
        className={`w-full h-full object-${objectFit} ${!imageLoaded ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300 ${className.includes('rounded') ? className.match(/rounded-[\w]+/)?.[0] || '' : ''}`}
        loading={loading}
        decoding={decoding}
        onError={handleImageError}
        onLoad={handleImageLoad}
        style={{
          // Optimize rendering for photos on high-DPI displays
          imageRendering: 'high-quality',
          WebkitImageRendering: '-webkit-optimize-contrast',
          MozImageRendering: '-moz-crisp-edges',
          msImageRendering: '-ms-interpolation-mode: bicubic',
          // Force hardware acceleration for smooth scaling
          transform: 'translateZ(0)',
          backfaceVisibility: 'hidden',
          perspective: '1000px'
        }}
        {...props}
      />
    </div>
  );
};

export default OptimizedImage; 